module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"popup":{"title":"Do you want to copy job position details provided in the Sponsor Licence application?","subtitle":"You’ll be able to review and edit them if needed.","actions":{"createNew":"Create new","copyFromSL":"Copy"}}}}')
  delete Component.options._Ctor
}
